// ENDING96 V2 — GSAP + ScrollTrigger

(function () {
  var gsapScript = document.createElement('script');
  gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  gsapScript.onload = function () {
    var stScript = document.createElement('script');
    stScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
    stScript.onload = initGSAP;
    document.head.appendChild(stScript);
  };
  document.head.appendChild(gsapScript);
})();

function initGSAP() {
  gsap.registerPlugin(ScrollTrigger);

  // ── LANDING TITLE — BLUR IN + TWO RED LINES + TV STATIC ─────────
  var landingTitle = document.querySelector('.landing__title');
  if (landingTitle) {

    // Blur in entrance
    gsap.fromTo(landingTitle,
      { opacity: 0, y: 30, filter: 'blur(14px)' },
      { opacity: 1, y: 0, filter: 'blur(0px)', duration: 1.6, ease: 'power3.out', delay: 0.3 }
    );
    gsap.fromTo('.landing__num',
      { opacity: 0, y: 10 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', delay: 1.0 }
    );
    gsap.fromTo('.landing__cta',
      { opacity: 0, y: 10 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', delay: 1.5 }
    );

    // Inject two thick red lines over NG (right ~55% of the word)
    // Lines are absolutely positioned divs on the title wrapper
    landingTitle.style.position = 'relative';
    landingTitle.style.display = 'inline-block';

    var line1 = document.createElement('div');
    var line2 = document.createElement('div');
    var lineStyle = 'position:absolute;right:0;width:38%;background:#d32a2a;pointer-events:none;opacity:0;';
    line1.style.cssText = lineStyle + 'height:6px;top:38%;';
    line2.style.cssText = lineStyle + 'height:6px;top:55%;';
    landingTitle.appendChild(line1);
    landingTitle.appendChild(line2);

    // Lines fade in after title settles
    gsap.to([line1, line2], { opacity: 1, duration: 0.3, delay: 1.9, stagger: 0.1, ease: 'power2.out' });

    // TV static flicker — authentic old television feel
    // Combination of: rapid brightness drop, horizontal desync, slight vertical jump
    function tvStatic() {
      var tl = gsap.timeline();
      tl.to(landingTitle, { filter: 'brightness(0.1) contrast(3)', x: 8,  duration: 0.03, ease: 'none' })
        .to(landingTitle, { filter: 'brightness(1)',               x: -5, duration: 0.03, ease: 'none' })
        .to(landingTitle, { filter: 'brightness(0.05)',            x: 0,  y: 3, duration: 0.02, ease: 'none' })
        .to(landingTitle, { filter: 'brightness(1.3)',             x: 4,  y: 0, duration: 0.03, ease: 'none' })
        .to(landingTitle, { filter: 'brightness(0.1)',             x: -3, duration: 0.02, ease: 'none' })
        .to(landingTitle, { filter: 'brightness(1)',               x: 0,  duration: 0.04, ease: 'none' });

      // Lines also flicker during static
      tl.to([line1, line2], { opacity: 0, x: 6, duration: 0.03, ease: 'none' }, 0)
        .to([line1, line2], { opacity: 1, x: 0, duration: 0.05, ease: 'none' }, 0.1);
    }

    setTimeout(function () {
      tvStatic();
      function scheduleNext() {
        setTimeout(function () { tvStatic(); scheduleNext(); }, 5000 + Math.random() * 6000);
      }
      scheduleNext();
    }, 2800);
  }

  // ── ARCHIVE GRID — STAGGER ─────────────────────────────────────
  var cards = document.querySelectorAll('.product-card');
  if (cards.length) {
    gsap.fromTo(cards,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 0.9, stagger: 0.12, ease: 'power3.out',
        scrollTrigger: { trigger: '.archive__grid', start: 'top 80%' }
      }
    );
  }

  // ── HISTORY — REDACTED REVEAL ──────────────────────────────────
  var frames = document.querySelectorAll('.history__frame');
  frames.forEach(function (frame) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:absolute;inset:0;background:#0c0b09;z-index:3;transform-origin:left;pointer-events:none;';
    frame.style.position = 'relative';
    frame.appendChild(overlay);

    ScrollTrigger.create({
      trigger: frame,
      start: 'top 75%',
      onEnter: function () {
        gsap.to(overlay, { scaleX: 0, duration: 1.4, ease: 'power4.inOut', transformOrigin: 'right' });
      }
    });
  });

  // ── HISTORY — TYPEWRITER ───────────────────────────────────────
  var blurbs = document.querySelectorAll('.history__blurb');
  blurbs.forEach(function (blurb) {
    var fullText = blurb.getAttribute('data-text') || blurb.textContent.trim();
    blurb.setAttribute('data-text', fullText);
    blurb.textContent = '';
    ScrollTrigger.create({
      trigger: blurb,
      start: 'top 82%',
      onEnter: function () {
        var i = 0;
        var interval = setInterval(function () {
          blurb.textContent += fullText[i];
          i++;
          if (i >= fullText.length) clearInterval(interval);
        }, 18);
      }
    });
  });

  // ── HISTORY — PARALLAX ─────────────────────────────────────────
  if (window.innerWidth > 640) {
    document.querySelectorAll('.history__block').forEach(function (block) {
      var img = block.querySelector('img');
      if (!img) return;
      gsap.set(img, { scale: 1.1 });
      gsap.to(img, {
        yPercent: -8, ease: 'none',
        scrollTrigger: { trigger: block, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  }

  // ── FADE IN ────────────────────────────────────────────────────
  document.querySelectorAll('.fade-in').forEach(function (el) {
    gsap.fromTo(el,
      { opacity: 0, y: 24 },
      { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 82%' }
      }
    );
  });

  // ── PRODUCT IMAGE — 3D TILT, BLACK BEHIND ─────────────────────
  var gallery = document.getElementById('productGallery');
  if (gallery) {
    // Ensure black bg shows through on tilt
    gallery.style.background = '#0c0b09';
    gallery.style.transformStyle = 'preserve-3d';

    gallery.addEventListener('mousemove', function (e) {
      var rect = gallery.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width - 0.5) * 12;
      var y = ((e.clientY - rect.top) / rect.height - 0.5) * -8;
      gsap.to(gallery, {
        rotationY: x, rotationX: y,
        duration: 0.5, ease: 'power2.out',
        transformPerspective: 1000
      });
    });
    gallery.addEventListener('mouseleave', function () {
      gsap.to(gallery, { rotationY: 0, rotationX: 0, duration: 0.9, ease: 'elastic.out(1, 0.6)' });
    });
  }

  // ── IMAGE GALLERY SWIPE ────────────────────────────────────────
  var track = document.getElementById('galleryTrack');
  var prevBtn = document.getElementById('galleryPrev');
  var nextBtn = document.getElementById('galleryNext');
  var dots = document.querySelectorAll('.product-gallery__dot');
  var current = 0;
  var total = dots.length;

  function goTo(index) {
    if (!track) return;
    current = (index + total) % total;
    gsap.to(track, { x: -(current * 100) + '%', duration: 0.6, ease: 'power3.inOut' });
    dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () { goTo(parseInt(this.getAttribute('data-index'))); });
  });

  if (gallery) {
    var startX = 0;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  // ── SIZE BUTTONS ───────────────────────────────────────────────
  var sizeBtns = document.querySelectorAll('.size-btn:not(.sold-out)');
  var stockEl = document.querySelector('.product-page__stock');
  var variantInput = document.getElementById('variant-id');

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sizeBtns.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      if (variantInput) variantInput.value = this.getAttribute('data-variant-id');
      var qty = this.getAttribute('data-qty') || '0';
      if (stockEl) {
        stockEl.textContent = qty + '/5 remaining';
        gsap.killTweensOf(stockEl);
        gsap.fromTo(stockEl, { opacity: 0.3 }, { opacity: 1, duration: 0.3 });
        gsap.to(stockEl, { opacity: 0.4, duration: 1.4, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 0.3 });
      }
      if (navigator.vibrate) navigator.vibrate(40);
    });
  });

  // ── SIZE GUIDE MODAL ───────────────────────────────────────────
  var sizeGuideLink = document.querySelector('.product-page__size-guide-link');
  var overlay = document.querySelector('.size-guide-overlay');
  var closeBtn = document.querySelector('.size-guide__close');
  var tabs = document.querySelectorAll('.size-guide__tab');

  if (sizeGuideLink && overlay) {
    sizeGuideLink.addEventListener('click', function () {
      overlay.style.display = 'flex';
      gsap.fromTo(overlay, { opacity: 0 }, { opacity: 1, duration: 0.3, ease: 'power2.out' });
      gsap.fromTo('.size-guide', { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.4, ease: 'power3.out' });
    });
  }
  function closeOverlay() {
    gsap.to(overlay, { opacity: 0, duration: 0.2, ease: 'power2.in',
      onComplete: function () { overlay.style.display = 'none'; }
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var t = this.getAttribute('data-tab');
      tabs.forEach(function (x) { x.classList.remove('active'); });
      this.classList.add('active');
      document.querySelectorAll('.size-guide__table').forEach(function (x) { x.style.display = 'none'; });
      var tbl = document.querySelector('.size-guide__table--' + t);
      if (tbl) { tbl.style.display = 'table'; gsap.fromTo(tbl, { opacity: 0 }, { opacity: 1, duration: 0.3 }); }
      var note = document.getElementById('size-guide-note');
      if (note) note.textContent = t === 'female' ? 'Women with a larger bust should size up.' : '';
    });
  });

  // ── CART BADGE ─────────────────────────────────────────────────
  var cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    cartForm.addEventListener('submit', function () {
      var badge = document.createElement('p');
      badge.textContent = 'Item recovered.';
      badge.style.cssText = 'font-size:8px;letter-spacing:.2em;color:#d32a2a;text-transform:uppercase;margin-top:12px;opacity:0;';
      var purchase = document.querySelector('.product-page__purchase');
      if (purchase) {
        purchase.parentNode.insertBefore(badge, purchase.nextSibling);
        gsap.to(badge, { opacity: 1, duration: 0.4 });
        setTimeout(function () { gsap.to(badge, { opacity: 0, duration: 0.4, onComplete: function () { badge.remove(); } }); }, 3000);
      }
    });
  }
}

// Nav logo stutter — no GSAP needed
document.addEventListener('DOMContentLoaded', function () {
  var navLogo = document.querySelector('.nav__logo-text');
  if (navLogo) {
    setInterval(function () {
      navLogo.style.transform = 'translateX(-2px) skewX(2deg)';
      setTimeout(function () { navLogo.style.transform = 'translateX(1px)'; }, 60);
      setTimeout(function () { navLogo.style.transform = ''; }, 110);
    }, 7000);
  }
});
